import { PlayIcon } from "@heroicons/react/solid";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getMovieDetails } from "../features/movieSlice";

const MoveCard = ({
  image,
  title,
  overview,
  vote_average,
  release_date,
  vote_count,
  poster_path,
  popularity,
  media_type,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const selectMovieDetails = () => {
    dispatch(
      getMovieDetails({
        image,
        title,
        overview,
        vote_average,
        release_date,
        vote_count,
        poster_path,
        popularity,
        media_type,
      })
    );
    history.push("/details");
  };

  return (
    <div
      className="mt-3 group transition border border-gray-800 duration-200 ease-in transform sm:hover:scale-105 shadow-lg hover:z-50 rounded-lg cursor-pointer"
      onClick={selectMovieDetails}
    >
      <div>
        <div className="flex flex-col">
          <div className="group-first">
            <img src={image} alt="" className="group cursor-pointer" />
          </div>
          <div className="border border-gray-800 p-1 bg-gray-800">
            <div className="flex items-center">
              <div className="px-2">
                <PlayIcon className="h-7  sm:h-10 text-gray-400 group-hover:text-green-400" />
              </div>
              <h1 className="text-white text-base sm:text-xl font-bold">
                {title}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveCard;
